import { render, staticRenderFns } from "./CurrencyEditComponent.vue?vue&type=template&id=23205472"
import script from "./CurrencyEditComponent.vue?vue&type=script&lang=js"
export * from "./CurrencyEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CurrencyEditComponent.vue?vue&type=style&index=0&id=23205472&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports